export default __webpack_public_path__ + "static/media/0162.dfe8500d.jpg";